const getOfferId = (): string => {
    return window.location.pathname.split('/')[1] || '';
}
export default getOfferId;